import {SDrawerOrModal, SGeneralForms} from "shj-components";
import {trimStr} from "@/utils/data.ts";
import {useEffect, useRef, useState} from "react";
import {isEmpty} from "lodash-es";
import {seatIpConfigSave, seatIpConfigUpdate} from "@/services/saleOpServices.ts";
import {message} from "antd";

export const AddOrEdit = (props) => {
  const {record, open, setOpen, onReload} = props

  const formRef = useRef()
  const [btnLoading, setBtnLoading] = useState(false)

  useEffect(() => {
    formRef.current?.onFormRef().resetFields()
    !isEmpty(record) && formRef.current?.onFormRef()?.setFieldsValue(record)
  }, [record]);

  const onSubmit = () => {
    formRef.current?.onFormRef().validateFields().then(values => {
      setBtnLoading(true)
      const values_ = {
        ...values,
      }
      const apiUrl = values.id ? seatIpConfigUpdate : seatIpConfigSave
      apiUrl(values_).then((res: any) => {
        message.success(res.message || '操作成功');
        setOpen(false)
        onReload();
      }).finally(() => {
        setBtnLoading(false)
      })
    })
  }

  return <SDrawerOrModal
      title={(record.id ? '编辑' : '新增')}
      mode="modal"
      open={open}
      loading={btnLoading}
      onCancel={() => setOpen(false)}
      onOk={onSubmit}
      width={500}
  >
    <SGeneralForms
        ref={formRef}
        layout={'vertical'}
        configs={[
          {
            formItem: [
              {label: 'id', name: 'id', hidden: true},
              {
                label: '通道名称',
                name: 'name',
                required: true,
                rules: [{required: true, message: '通道名称不能为空'}],
                spanCol: 24,
                comConfig: {
                  showCount: true, maxLength: 20,
                  onChange: (e) => formRef.current?.onFormRef()?.setFieldValue('name', trimStr(e.target.value))
                }
              },
              {
                label: '通道地址',
                name: 'ip',
                required: true,
                rules: [{required: true, message: '通道地址不能为空'}],
                spanCol: 24,
                comConfig: {
                  showCount: true, maxLength: 200,
                  onChange: (e) => formRef.current?.onFormRef()?.setFieldValue('ip', trimStr(e.target.value))
                }
              },
              {
                label: 'appid',
                name: 'appid',
                required: true,
                rules: [{required: true, message: 'appid不能为空'}],
                spanCol: 24,
                comConfig: {
                  showCount: true, maxLength: 200,
                  onChange: (e) => formRef.current?.onFormRef()?.setFieldValue('appid', trimStr(e.target.value))
                }
              },
              {
                label: '密钥',
                name: 'secretKey',
                required: true,
                rules: [{required: true, message: '密钥不能为空'}],
                spanCol: 24,
                comConfig: {
                  showCount: true, maxLength: 200,
                  onChange: (e) => formRef.current?.onFormRef()?.setFieldValue('secretKey', trimStr(e.target.value))
                }
              },
            ],
          },
        ]}
    />
  </SDrawerOrModal>
}